import { PickType } from '@nestjs/swagger';
import { SpModelNameDto } from './sp-model-name.dto';
import { SpModelNameMapableInterface } from '../interfaces/sp-model-name-mapable.interface';

export class SpModelNameMapableDto
  extends PickType(SpModelNameDto, ['modelId'])
  implements SpModelNameMapableInterface {}
